import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      fontSize: 14,
      fontWeight: 600,
      marginBlockEnd: 16,
    },
  },
  { name: 'SidebarHeading' },
);
